import React, { ReactNode } from 'react';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';

interface HoverCardProps {
  /** The hover trigger. */
  children: ReactNode;
  /** Interactive content shown next to the trigger. */
  content: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  sideOffset?: number;
  /** Render as a plain wrapper when false. */
  enabled?: boolean;
  /** Close the card programmatically (e.g. after navigating). */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

/**
 * Radix hover card: a hover-triggered floating panel whose content stays
 * interactive (unlike a tooltip). Used for the collapsed-sidebar submenu
 * flyouts.
 */
export const HoverCard: React.FC<HoverCardProps> = ({
  children,
  content,
  side = 'right',
  align = 'start',
  sideOffset = 8,
  enabled = true,
  open,
  onOpenChange,
}) => {
  if (!enabled) return <>{children}</>;
  return (
    <HoverCardPrimitive.Root openDelay={100} closeDelay={150} open={open} onOpenChange={onOpenChange}>
      <HoverCardPrimitive.Trigger asChild>{children}</HoverCardPrimitive.Trigger>
      <HoverCardPrimitive.Portal>
        <HoverCardPrimitive.Content
          side={side}
          align={align}
          sideOffset={sideOffset}
          className="z-[9999] min-w-[200px] rounded-10 bg-white p-[6px] shadow-3"
        >
          {content}
        </HoverCardPrimitive.Content>
      </HoverCardPrimitive.Portal>
    </HoverCardPrimitive.Root>
  );
};
